@if (shouldRender()) {
  <p-dialog
    [visible]="visible()"
    (visibleChange)="onVisibleChange($event)"
    (onHide)="onDialogHide()"
    [modal]="true"
    [dismissableMask]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="true"
    [motionOptions]="dialogMotionOptions"
    [maskMotionOptions]="maskMotionOptions"
    maskStyleClass="app-lightbox-mask"
    styleClass="app-lightbox-panel"
    [style]="{
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      margin: '0',
      transform: 'none'
    }"
    [contentStyle]="{
      padding: '0',
      height: '100%',
      overflow: 'hidden',
      background: 'transparent'
    }"
  >
    <div class="lightbox-wrapper">
      <button class="close-btn" type="button" aria-label="Zamknij" (click)="close()">
        <i class="pi pi-times"></i>
      </button>

      <div class="main-content">
        <button
          class="nav-trigger prev"
          type="button"
          [class.hidden]="media().length <= 1"
          (click)="prev(); $event.stopPropagation()"
        >
          <i class="pi pi-chevron-left"></i>
        </button>

        <div class="image-stage">
          <div class="image-viewport">
            @if (activeItem()?.thumbnail) {
              <img [src]="activeItem()?.thumbnail" class="image-placeholder" aria-hidden="true" />
            }

            @if (activeItem(); as item) {
              <img
                [src]="item.url"
                [alt]="item.name"
                class="active-image"
                fetchpriority="high"
                (click)="$event.stopPropagation()"
                (load)="onImageLoad($event)"
              />
            }
          </div>

          @if (activeItem()?.name) {
            <div class="image-meta">
              <span class="image-title">{{ activeItem()?.name }}</span>
              <span class="image-counter">{{ activeIndex() + 1 }} / {{ media().length }}</span>
            </div>
          }
        </div>

        <button
          class="nav-trigger next"
          type="button"
          [class.hidden]="media().length <= 1"
          (click)="next(); $event.stopPropagation()"
        >
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>

      @if (media().length > 1) {
        <div class="filmstrip-container">
          <div class="filmstrip">
            @for (item of media(); track trackMedia($index, item)) {
              <button
                class="film-thumb"
                type="button"
                [class.active]="$index === activeIndex()"
                (click)="setActiveIndex($index); $event.stopPropagation()"
              >
                <img [src]="item.thumbnail || item.url" [alt]="item.name" loading="lazy" />
              </button>
            }
          </div>
        </div>
      }

      <div class="image-preload-cache" aria-hidden="true">
        @if (nextItem(); as item) {
          <img [src]="item.url" alt="" />
        }
        @if (prevItem(); as item) {
          <img [src]="item.url" alt="" />
        }
      </div>
    </div>
  </p-dialog>
}
